export const GET_PLANS_LOADING = "GET_PLANS_LOADING";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLANS_FAILED = "GET_PLANS_FAILED";

export const GET_PLANS_COMPARATIVE_LOADING = "GET_PLANS_COMPARATIVE_LOADING";
export const GET_PLANS_COMPARATIVE_SUCCESS = "GET_PLANS_COMPARATIVE_SUCCESS";
export const GET_PLANS_COMPARATIVE_FAILED = "GET_PLANS_COMPARATIVE_FAILED";
